<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2" style="margin-bottom: 30px">
            <h3>{{ $t('token.csv.title-label') }}</h3>
        </div>
        <!-- ウォレット取引履歴 CSV出力 -->
        <p class="mb-0 text-left hec_data_history_csv_message">{{ $t('token.csv.hec_data_history_csv_message') }}</p>
        <p class="mb-0 text-left">{{ $t('token.csv.target_year_message') }}</p>
        <div class= "mx-auto user-details-text input-group">
            <select class="form-control" id="hec-data-history-csv-select">
                <option selected hidden></option>
                <option v-for="targetYear of targetPeriod" :value="targetYear">{{ targetYear }}</option>
            </select>
            <div class="input-group-append">
                <button class="btn mb-2 hec-data-history-csv-button" type="button" @click="handleOnClickDownloadHecDataHistoryCsv()">{{ $t('token.csv.hec_data_history_csv_button') }}</button>
            </div>
        </div>
        <div id="target_id_err_message_csv" class="err-message-hidden-csv">{{ $t('token.csv.err_message_csv') }}</div>
        <!-- /ウォレット取引履歴 CSV出力 -->
    </div>
</template>

<script>
    import tokenService from './../../services/TokenService';
    import downloadFileUtil from './../../utils/DownloadFileUtil';

    export default {
        name: 'TokenCsv',

        data() {
            return {
                // ウォレット取引履歴 CSV出力
                targetPeriod: [],
                startYear: '',
                date: '',
                period: '',
                targetYear: '',
            }
        },

        created() {
            // ウォレット取引履歴 CSV出力 対象期間
            this.startYear = 2019
            this.date      = new Date()
            this.year      = this.date.getFullYear()
            this.period    = Number(this.year) - this.startYear

            for(let i = 0; i < this.period + 1; i++){
                this.targetPeriod.push(this.year - i)
            }
        },

        methods: {
            // ウォレット取引履歴 CSV出力
            async handleOnClickDownloadHecDataHistoryCsv() {
                //対象期間取得
                this.targetYear = document.getElementById("hec-data-history-csv-select").value

                //CSV出力値取得
                const resultList = await Promise.all([
                    tokenService.getHecDataHistoryListExport({
                        targetYear: this.targetYear,
                    })
                ])

                if(resultList[0].data){
                    //該当する実績がある場合 エラー文字非表示 
                    document.querySelector('#target_id_err_message_csv').classList.replace('err-message-display-csv', 'err-message-hidden-csv')
                    //CSV出力
                    downloadFileUtil.download(resultList[0].data, "HecDataHistory_"+ this.targetYear+".csv")
                }else{
                    //該当する実績がない場合 エラー文字表示
                    document.querySelector('#target_id_err_message_csv').classList.replace('err-message-hidden-csv', 'err-message-display-csv')
                } 
            },
        },
    }
</script>

<style scoped>
    .hec_data_history_csv_message {
        margin-bottom: 20px!important;
    }
    #hec-data-history-csv-select {
        max-width: 200px;
    }
    .hec-data-history-csv-button {
        z-index: 0;
        color: #fff;
        background-color: #350f71;
        border-color: #350f71;
    }
    .hec-data-history-csv-button:hover {
        color: #fff !important;
    }
    .err-message-hidden-csv {
        visibility:hidden;
        padding-bottom: 10px;
    }
    .err-message-display-csv {
        color: #e3342f;
    }
</style>
